import Button from 'devextreme-react/button';
import Popup, { ToolbarItem } from 'devextreme-react/popup';
import { useContext, useState } from 'react';
import { MaterialOrderContext } from '../context/MaterialOrderContext';
import MaterialOrderDatesGrid from './MaterialOrderDatesGrid';

export default function ShowMaterialDatesButton() {

	const { order } = useContext(MaterialOrderContext);
	const [isPopupVisible, setPopupVisibility] = useState(false);

	return (
		<>
			<Button
				text="Show Material Dates"
				icon="Inscyth-Change-Orders"
				visible={order.details.purchaseOrders.length > 0}
				disabled={isPopupVisible}
				onClick={() => setPopupVisibility(true)}
			>
			</Button>
			<Popup
				title="Material Order Dates"
				visible={isPopupVisible}
				hideOnOutsideClick={true}
				onHiding={() => setPopupVisibility(false)}
			>
				<ToolbarItem
					options={{
						icon: 'dx-icon dx-icon-close',
						onClick: () => setPopupVisibility(false)
					}}
					widget="dxButton"
					location="after"
				/>

				<MaterialOrderDatesGrid records={order.details.purchaseOrders} />
			</Popup>
		</>
	);
}
